export function normalizeRequestMetadata(source) {
  const rawStatus = source?.status;
  const numericStatus =
    rawStatus === undefined || rawStatus === null || rawStatus === ''
      ? null
      : Number(rawStatus);

  return {
    status: Number.isNaN(numericStatus) ? null : numericStatus,
    correlationId: source?.correlationId || source?.correlation || '',
  };
}

export function normalizeErrorMessage(data) {
  if (typeof data === 'string') {
    return data;
  }

  if (data === undefined || data === null) {
    return '';
  }

  try {
    return JSON.stringify(data);
  } catch {
    return String(data);
  }
}

export function normalizeGeneratedCode(data) {
  if (typeof data !== 'string') {
    return data;
  }

  try {
    return JSON.parse(data);
  } catch {
    return data;
  }
}

export function createFailurePayload(error) {
  const metadata = normalizeRequestMetadata(error);

  return {
    ...metadata,
    message: normalizeErrorMessage(error?.data),
  };
}

export function isAbortError(error) {
  return error?.name === 'AbortError';
}
